import { flattenConnection } from "@lib/shopifyUtils";

export function getMediaListFromProduct(productGroup, currentProduct) {

  if (!productGroup || !currentProduct) {
    return [];
  }
  if (!productGroup.shopifyProducts) {
    return [];
  }
  const shopifyProduct = productGroup.shopifyProducts.find(
    (shopifyProduct) =>
      shopifyProduct.productReferenceV2.id === currentProduct.productReferenceV2.id
  );

  if (shopifyProduct) {
    return flattenConnection(shopifyProduct.media);
  }
  return [];
}
